import { CartAddEvent } from '@theme/events';

/**
 * Classics quick add.
 * Any <form data-cl-add> posts every [name="id"] value it holds (checked radios, selects, hidden inputs)
 * to the cart in one request, refreshes the cart drawer and opens it.
 */

function sectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

export async function classicsAddToCart(items) {
  const ids = sectionIds();
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items, sections: ids.join(',') }),
  });
  const json = await response.json();
  if (!response.ok || json.status) {
    throw new Error(json.description || json.message || 'Toevoegen lukte niet.');
  }

  document.dispatchEvent(
    new CartAddEvent({}, 'classics-quick-add', {
      source: 'classics-quick-add',
      itemCount: items.reduce((sum, item) => sum + (item.quantity || 1), 0),
      sections: json.sections,
    })
  );

  const drawer = document.querySelector('cart-drawer-component');
  const dialog = drawer?.querySelector('dialog');
  if (drawer && dialog && !dialog.open && typeof drawer.open === 'function') drawer.open();
  return json;
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cl-add')) return;
  event.preventDefault();

  const button = form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-cl-error]');
  const ids = new FormData(form).getAll('id').filter(Boolean);

  if (error) error.textContent = '';
  if (!ids.length) {
    if (error) error.textContent = form.dataset.clNeedSize || 'Kies eerst je maat.';
    return;
  }

  const label = button ? button.innerHTML : '';
  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }

  try {
    await classicsAddToCart(ids.map((id) => ({ id: Number(id), quantity: 1 })));
    if (button) button.innerHTML = form.dataset.clAdded || 'Toegevoegd';
    form.dispatchEvent(new CustomEvent('classics:added', { bubbles: true }));
    setTimeout(() => {
      if (button) button.innerHTML = label;
    }, 1800);
  } catch (e) {
    if (error) error.textContent = e.message;
    if (button) button.innerHTML = label;
  } finally {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
});
